import React from 'react';
import { useNavigate } from 'react-router-dom';  // Replace useHistory with useNavigate
import './land.css';

const LandPage = () => {
  const navigate = useNavigate();  // Use useNavigate instead of useHistory

  // Function to navigate to main.js (Air Aware Section)
  const goToAirAware = () => {
    navigate('/main'); // Navigating to the main.js page
  };

  // Function to navigate to people.js (Social Responsibility Section)
  const goToSocialResponsibility = () => {
    navigate('/people'); // Navigating to the people.js page
  };

  return (
    <div className="landing-page">
      <header className="landing-header">
        <h1 className="text-3xl font-bold text-center mt-6">Welcome to Air Quality Awareness</h1>
        <p className="text-center text-gray-600">Click a section below to learn more and take action!</p>
      </header>

      <section className="sections-container flex justify-around mt-8">
        <div
          className="section-card bg-blue-500 text-white p-6 rounded-lg shadow-md cursor-pointer hover:bg-blue-600"
          onClick={goToAirAware}
        >
          <h2 className="text-xl font-semibold text-center">Air Aware</h2>
          <p className="text-center mt-2">Learn about air quality and how you can stay informed.</p>
        </div>

        <div
          className="section-card bg-green-500 text-white p-6 rounded-lg shadow-md cursor-pointer hover:bg-green-600"
          onClick={goToSocialResponsibility}
        >
          <h2 className="text-xl font-semibold text-center">Social Responsibility</h2>
          <p className="text-center mt-2">Join initiatives to help improve air quality in your community.</p>
        </div>
      </section>
    </div>
  );
};

export default LandPage;
